<template>
  <div class="why-us">
    <div
      class="why-us_banner"
      :style="{
        backgroundImage:
          'url(' +
          require('../../../assets/images/online-service/' + imgUrl + '.png') +
          ')',
      }"
    >
      <h2 class="why-us_banner_title">
        {{ nameUrl }}
      </h2>
      <div class="why-us_banner_sub-title">Online Service</div>
    </div>
    <tabs @name="setName">
      <!-- <tab name="my-booking" v-if="userData!==null">
        <my-booking :cards="booking['my-booking'].cards"/>
      </tab> -->
      <tab name="booking-online">
        <booking-online :cards="booking['booking-online'].cards"/>
      </tab>
      <tab name="schedule">
        <schedule :cards="booking['schedule'].cards"/>
      </tab>
      <tab name="track-trace">
        <track-trace :cards="booking['track-trace'].cards"/>
      </tab>
      <tab name="cfs-finder">
        <cfs-finder :cards="booking['cfs-finder'].cards"/>
      </tab>
    </tabs>
  </div>
</template>

<script>
import { reactive, ref, computed } from "@vue/composition-api";
// import { useRoute } from "vue-router";
export default {
  name: "booking",
  components: {
    Tabs: () => import("@/@core/components/tabs"),
    Tab: () => import("@/@core/components/tab"),
    BookingOnline: () => import("./components/booking-online"),
    CfsFinder: () => import("./components/cfs-finder"),
    Schedule: () => import("./components/schedule"),
    TrackTrace: () => import("./components/track-trace"),
    // MyBooking: () => import("./components/my-booking")
  },
  created() {
  },
  setup(props) {
    const onNameUrl = ref("");
    const booking = reactive({
      // "my-booking": {
      //   name: "Booking Online",
      //   img: "my-booking",
      //   cards: [{},],
      // },
      "booking-online": {
        name: "Booking Online",
        img: "booking-online",
        cards: [{},],
      },
      "track-trace": {
        name: "Track & Trace",
        img: "track-trace",
        cards: [{},],
      },
      "cfs-finder": {
        name: "CFS Finder",
        img: "cfs-finder",
        cards: [{},],
      },
      "schedule": {
        name: "Schedule",
        img: "schedule",
        cards: [{},],
      },
    });
    function setName(name) {
      onNameUrl.value = name;
    }
    const imgUrl = computed(
      () => booking[onNameUrl.value]?.img || "booking-online"
    );

    const nameUrl = computed(() => booking[onNameUrl.value]?.name || "");

    return {
      booking,
      setName,
      onNameUrl,
      imgUrl,
      nameUrl,
      userData: JSON.parse(localStorage.getItem('userData'))
    };
  },
  watch: {
    $route() {
      this.userData = JSON.parse(localStorage.getItem('userData'))
    },    
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/style.scss";
.why-us {
  height: 100%;
  &_banner {
    height: 413px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    &_title {
      text-align: center;
      position: absolute;
      text-transform: uppercase;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      font-weight: 900;
      font-size: var(--big-font-size);
      line-height: 45px;
      text-align: center;
      letter-spacing: 0.155em;

      color: #ffffff;
    }
    &_sub-title {
      font-weight: 600;
      font-size: var(--normal-font-size);
      line-height: 22px;
      letter-spacing: -0.02em;
      position: absolute;
      bottom: 3%;
      left: 0%;
      color: #2b938c;
      background: #f8f7f7;
      padding: 10px 40px;
      width: 100%;
    }
  }
  h1 {
    text-align: center;
    font-weight: 900;
    font-size: var(--big-font-size);
    line-height: 45px;
    text-align: center;
    letter-spacing: 0.155em;
    color: #2b938c;
    padding: 100px;
  }
}
</style>